import {orderSupplierNameSelector} from '../../../data/orders.js'
import {useSelector} from '../../../store.js'

export default function OrderSupplier({orderNumber}) {
  const supplierName = useSelector((state) =>
    orderSupplierNameSelector(state, {orderNumber}),
  )

  return <span>{supplierName}</span>
}
